import { Dialog, DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { useCiudadesStore, type RegistrarCiudad } from '../../stores/ciudades/ciudades.store';
import CiudadForm from './CiudadForm';

interface CiudadAddDialogProps {
  open: boolean;
  onClose: () => void;
  onAddSuccess: (newId: number) => void;
}

const CiudadAddDialog = ({ open, onClose, onAddSuccess }: CiudadAddDialogProps) => {
  const { nuevo, registrar } = useCiudadesStore();

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = async (values: RegistrarCiudad) => {
    const result = await registrar(values);
    if (result) {
      onAddSuccess(result);
    }
    return result;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <CiudadForm esAgregar={true} onSave={handleSave} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default CiudadAddDialog;
